<template>
  <el-dialog
    :title="$t('common.confirm')"
    :visible.sync="dialogVisible"
    width="500px"
    @close="handleClose">
    <div style="text-align:center;margin-bottom:20px;">
      <p>{{ $t('productPriceRule.confirmDeletePriceRule') }}</p>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="deleteProductPriceRule">{{ $t('common.confirmDelete') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getShopId } from '@/api/shop/shopApi'
import { deleteProductPriceRule } from '@/api/goods/productPriceRuleApi'

export default {
  name: 'DeleteProductPriceRule',
  data() {
    return {
      dialogVisible: false,
      deleteProductPriceRuleInfo: {
        ruleId: '',
        shopId: ''
      }
    }
  },
  methods: {
    open(row) {
      this.deleteProductPriceRuleInfo.ruleId = row.ruleId
      this.dialogVisible = true
    },
    handleClose() {
      this.resetForm()
    },
    resetForm() {
      this.deleteProductPriceRuleInfo = {
        ruleId: '',
        shopId: ''
      }
    },
    deleteProductPriceRule() {
      this.deleteProductPriceRuleInfo.shopId = getShopId()
      deleteProductPriceRule(this.deleteProductPriceRuleInfo)
        .then(response => {
          this.$message.success(this.$t('common.submitSuccess'))
          this.dialogVisible = false
          this.$emit('refresh')
        })
        .catch(error => {
          console.error('删除失败:', error)
        })
    }
  }
}
</script>